var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounMagnifyingGlass202232222222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1017.6 960-224.4-224.4c-2.3984-2.3984-3.6016-3.6016-6-4.8008 102-134.4 91.199-327.6-31.199-450-134.4-134.4-352.8-134.4-487.2 0-134.4 134.4-134.4 352.8 0 487.2 122.4 122.4 315.6 133.2 450 31.199 1.1992 2.3984 3.6016 4.8008 4.8008 6l224.4 224.4c19.199 19.199 50.398 19.199 69.602 0 19.199-19.203 19.199-50.402 0-69.602zm-684-256.8c-98.398-98.398-98.398-259.2 0-357.6 98.398-98.398 259.2-98.398 357.6 0 98.398 98.398 98.398 259.2 0 357.6-98.402 98.402-259.2 99.602-357.6 0z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounMagnifyingGlass202232222222);
export default __webpack_public_path__ + "static/media/noun-magnifying-glass-202232-222222.9d6a5ef8ae864a072c5272f88f84b099.svg";
export { ForwardRef as ReactComponent };